import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ModelBrowserIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="modelBrowser" ref={ref} {...props}>
      <path d="M12.966,19.126l-1.647.951V11.924l6.619-3.252v2.017a4.986,4.986,0,0,1,1.5.724v-4.1a.751.751,0,0,0-.375-.65L10.944,1.974a.755.755,0,0,0-.75,0L2.074,6.662c-.016.01-.023.028-.039.039a.738.738,0,0,0-.189.189.656.656,0,0,0-.054.073c-.006.011-.017.019-.022.031A.724.724,0,0,0,1.7,7.3l0,.012v9.376a.749.749,0,0,0,.375.649l8.12,4.688a.747.747,0,0,0,.75,0l3.389-1.957A5.064,5.064,0,0,1,12.966,19.126Zm-3.147.951L3.2,16.255V8.492l6.62,3.1Zm1.088-9.622c-.007,0-.012-.01-.02-.014l-6.819-3.2,6.5-3.753,6.673,3.853ZM22.524,20.646l-2.688-2.689a4.22,4.22,0,0,0,.822-2.493,4.266,4.266,0,1,0-1.9,3.54l2.7,2.7a.75.75,0,1,0,1.06-1.06Zm-8.883-5.182A2.759,2.759,0,1,1,16.4,18.222,2.763,2.763,0,0,1,13.641,15.464Z" />
    </Icon>
  ),
) as IconWithRender;

ModelBrowserIcon.displayName = 'ModelBrowserIcon';
ModelBrowserIcon.renderIcon = (props) => <ModelBrowserIcon {...props} />;
export default ModelBrowserIcon;
